export default __webpack_public_path__ + "static/media/aboutus-5.d910ba1e.jpg";